<template>
  <v-row class="ma-4 mpc-criticality mx-auto">
    <v-col class="pa-0">
      <v-img src="@/assets/illustrations/criticality.svg" height="44px" width="44px" class="mx-auto"/>
      <div class="token-text-h4 mb-2 text-center">
        Cluster criticality
      </div>
      <div class="token-text-regular mb-6 text-center">
        What is you goal for this environment?
      </div>
      <div class="card">
        <CustomButton
          class="full-width mb-2"
          :level="$enums.ButtonLevels.Secondary"
          @click="$emit('update:criticality', $enums.ClusterCriticality.BASIC)"
        >
          {{ descriptions[$enums.ClusterCriticality.BASIC].main }}
        </CustomButton>
        <CustomButton
          class="full-width mb-2"
          :level="$enums.ButtonLevels.Secondary"
          @click="$emit('update:criticality', $enums.ClusterCriticality.STABLE)"
        >
          {{ descriptions[$enums.ClusterCriticality.STABLE].main }}
        </CustomButton>
        <CustomButton
          class="full-width mb-2"
          :level="$enums.ButtonLevels.Secondary"
          @click="$emit('update:criticality', $enums.ClusterCriticality.MISSION_CRITICAL)"
        >
          {{ descriptions[$enums.ClusterCriticality.MISSION_CRITICAL].main }}
        </CustomButton>
      </div>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Vue, Options, prop } from 'vue-class-component'
import enums from '@/enums';
import CustomButton from '@/components/UIElements/CustomButton.vue'

class Props {
  criticality: string = prop({
    required: true,
  });
}


@Options({
  components: {
    CustomButton
  },
})
export default class MPCClusterConfig extends Vue.with(Props) {

  descriptions:{[key:string]: {sub:string, main:string}} = {
    [enums.ClusterCriticality.BASIC]: {
      main: 'Minimizing costs, even if that means accepting occasional downtime',
      sub: 'Mono-node',
    },
    [enums.ClusterCriticality.STABLE]: {
      main: 'Balancing cost and reliability, stable infrastructure at a reasonable budget',
      sub: 'Stable sub description',
    },
    [enums.ClusterCriticality.MISSION_CRITICAL]: {
      main: 'Ensuring maximum availability and performance, even at higher cost',
      sub: 'Production sub description',
    },
  };

  mounted() {
    // Ensure the criticality is set to STABLE by default if not provided
    if (!this.criticality) {
      this.$emit('update:criticality', this.$enums.ClusterCriticality.STABLE);
    }

    
  }

}
</script>
<style lang="scss" scoped >
@import '@/css/variables';
.card-description {
  background-color: $color-neutral-grey-8;
  border-radius: 8px;
}
.mpc-criticality {
  width: calc(100% - 16px);
}
</style>